import { ITeamDisplayDTO } from '@/dtos';
import { getTeamDisplayDataAPI } from '@/services';

export async function getTeamDisplayData(year?: string): Promise<ITeamDisplayDTO[]> {
  try {
    const data = await getTeamDisplayDataAPI(year);
    return data;
  } catch {
    throw 'Cannot get teams';
  }
}
